export const environment = {
  nome: 'homolog',
  production: false,
  version: "1.0.32"
}
